// import React from 'react';
// import './style.css';
// import { COLORS } from "../../Constants/colors"

// export default class ScrollToTop extends React.Component {
//   constructor() {
//     super();

//     this.scrollToTop = this.scrollToTop.bind(this);
//   }

//   scrollToTop() {
//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth'
//     });
//   }

//   render() {
//     return (
//       <button 
//         title='Back to top' 
//         className='scroll-button' 
//         onClick={this.scrollToTop}
//         style={{ '--scroll-button-bg': COLORS.primary }}
//       >
//         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(-90)">
//           <path d="M5 12.5059H19" stroke={COLORS.buttonText} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
//           <path d="M12 19.5938L19 12.5114L12 5.42904" stroke={COLORS.buttonText} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
//         </svg>
//       </button>
//     );
//   }
// }


import React from 'react';
import './style.css';
import { COLORS } from "../../Constants/colors";

export default class ScrollToTop extends React.Component {
  constructor() {
    super();
    this.state = { isVisible: false };

    this.scrollToTop = this.scrollToTop.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll() {
    // Show only if scrolled 100px or more
    if (window.scrollY > 100) {
      this.setState({ isVisible: true });
    } else {
      this.setState({ isVisible: false });
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  render() {
    if (!this.state.isVisible) return null; // Don’t render button if not visible

    return (
      <button 
        title='Back to top' 
        className='scroll-button' 
        onClick={this.scrollToTop}
        style={{ '--scroll-button-bg': COLORS.primary }}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(-90)">
          <path d="M5 12.5059H19" stroke={COLORS.buttonText} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 19.5938L19 12.5114L12 5.42904" stroke={COLORS.buttonText} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    );
  }
}
